import UpdatedAtCell from 'components/cell/UpdatedAtCell';

export const TABLE_COLUMNS = [
  {
    Header: 'Name',
    accessor: 'contact_info.trading_name',
    subAccessors: [],
    items: [],
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
  },
  {
    Header: 'Subscribers',
    accessor: 'stats.subscribers',
    subAccessors: [],
    items: [],
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
  },
  {
    Header: 'Referrals',
    accessor: 'stats.total_referrals',
    subAccessors: [],
    items: [],
    width: 240,
    minWidth: 200,
    maxWidth: 2000,
  },
  {
    Header: 'Last Activity',
    accessor: 'metadata.updated_at',
    items: [
      {
        action: {
          type: 'activity-ascending',
        },
        icon: 'sort-ascending',
        name: 'Sort ascending',
      },
      {
        action: {
          type: 'activity-descending',
        },
        icon: 'sort-descending',
        name: 'Sort descending',
      },
    ],
    width: 140,
    renderComponent: {
      component: UpdatedAtCell,
      value: 'date',
    },
  },
];

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};

export const SORTING = {
  UPDATED_AT: 'UPDATED_AT',
  NAME: 'NAME',
  ID: 'ID',
  COMPANY: 'COMPANY',
};

export const ORDER = {
  NORMAL: 'NORMAL',
  INVERSE: 'INVERSE',
};

export const FILTER_TYPES = {
  NONE: 'NONE',
  STATUS: 'STATUS',
};

export const SEARCH_OPTIONS = {
  keys: [{ name: 'id', weight: 1 }],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};
